module.exports = __webpack_public_path__ + "img/dl-mockup.56b93c24.png";